import type { PublicPost } from "@vzlive/shared";

export function partitionTimeline(posts: PublicPost[]) {
  return {
    pinned: posts
      .filter((post) => post.pinnedPosition !== null)
      .sort(
        (first, second) =>
          (first.pinnedPosition ?? 0) - (second.pinnedPosition ?? 0),
      ),
    regular: posts.filter((post) => post.pinnedPosition === null),
  };
}

/** Copy before sorting so UI preferences never mutate the server payload. */
export function orderPosts(
  posts: PublicPost[],
  order: "newest" | "oldest",
): PublicPost[] {
  return [...posts].sort((a, b) => {
    const difference = Date.parse(a.publishedAt) - Date.parse(b.publishedAt);
    return order === "oldest" ? difference : -difference;
  });
}
